module.exports = __webpack_public_path__ + "img/disease-pic1.37505c1e.png";